const getIsActive = (name, features) => features.indexOf(name) !== -1;

export const isActive = (name, config) => {
    const features = config?.features || App.Config.activeFeatures;

    return getIsActive(`${name}.for_store_${config?.store}`, features) || getIsActive(name, features);
};
